import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Directive({
  selector: '[ellipsisTooltip]',
  providers: [MatTooltip],
})
export class EllipsisTooltipDirective {
  @Input('ellipsisTooltip') tooltipText = '';

  constructor(private el: ElementRef, private matTooltip: MatTooltip) {
    this.matTooltip.tooltipClass = 'opacity-90';
  }

  @HostListener('mouseenter')
  onMouseEnter() {
    const element = this.el.nativeElement as HTMLElement;
    const isTruncated = element.scrollWidth > element.clientWidth;

    if (isTruncated) {
      this.matTooltip.message = this.tooltipText;
      this.matTooltip.disabled = false;
      this.matTooltip.show();
    } else {
      this.matTooltip.disabled = true;
      this.matTooltip.hide();
    }
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    this.matTooltip.hide();
  }
}
